var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['totem-certification-badge', _vm.size],domProps:{"innerHTML":_vm._s(_vm.name)}})
}
var staticRenderFns = []

export { render, staticRenderFns }